import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'propensity-band',
    templateUrl: './propensity-band.component.html',
    styleUrls: ['./propensity-band.component.scss'],
})
export class PropensityBandComponent implements OnInit {
    @Input() showDesc: boolean = false;
    @Input() PTFScore?: string = '';
    PTFLabel: string;
    PTFDesc: string;

    constructor() {}

    ngOnInit() {
        [this.PTFDesc, this.PTFLabel] = this.labelScore();
        this.showDesc = this.showDesc ? this.showDesc : false;
    }

    labelScore(): string[] {
        let score: string = this.PTFScore;
        let label: string = '';
        let desc: string = '';

        if (score == null) {
            return [desc, label];
        }

        switch (score.toLowerCase()) {
            case 'very high':
                label = 'very high';
                desc = 'Very high propensity to fund within 90 days of application';
                break;
            case 'high':
                label = 'high';
                desc = 'High propensity to fund within 90 days of application';
                break;
            case 'medium':
                label = 'medium';
                desc = 'Medium propensity to fund within 90 days of application';
                break;
            case 'low':
                label = 'low';
                desc = 'Low propensity to fund within 90 days of application';
                break;
            case 'very low':
                label = 'very low';
                desc = 'Very low propensity to fund within 90 days of application';
                break;
            default:
                break;
        }

        return [desc, label];
    }
}
